import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faGraduationCap } from "@fortawesome/free-solid-svg-icons";

function PropifyAcademyAd() {
  return <a
      className="vd-propify-ad"
      href="https://propifyacademy.com/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Visit Propify Academy"
    >
      <span className="vd-propify-ad-label">Sponsored</span>
      <span className="vd-propify-ad-heading">
        <span className="vd-propify-ad-icon" aria-hidden="true">
          <FontAwesomeIcon icon={faGraduationCap} />
        </span>
        <span className="vd-propify-ad-copy">
          <span className="vd-propify-ad-title">Propify Academy</span>
          <span className="vd-propify-ad-description">Explore real estate learning with Propify Academy.</span>
        </span>
      </span>
      <span className="vd-propify-ad-link">
        Learn more
        <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
      </span>
    </a>;
}

export default PropifyAcademyAd;
